module.exports = __webpack_public_path__ + "static/media/logo.2a398284.png";